import { getDatasetFullLabel } from 'Common/utils';
export const getDatasetsNameMapper = (datasets) => datasets
    .reduce((acc, dataset) => {
    const { provider, name } = dataset;
    const datasetLabel = getDatasetFullLabel(provider, name);
    return Object.assign(Object.assign({}, acc), { [dataset.id]: datasetLabel });
}, {});
